/** Formula used to turn a readjustment percentage into the part sale value: markup over the cost, or margin over the sale value. */
export type PartPriceReadjustmentMode = "markup" | "margin";

export const DEFAULT_PART_PRICE_READJUSTMENT_MODE: PartPriceReadjustmentMode = "markup";
